

export let ForwardEmailOpts = {
  'CVOnly': 1,
  'ApplicationOnly': 2,
  'ApplicationCVCoverLetter': 3,
  'ApplicationWithAssessmentFormsCV': 4
};

export let ClientFeatures = {
  Feature_MultiDocs: 'Feature_MultiDocs',
};



export let InterviewType = {
  'Regular': 1,
  'Online': 2
};
export let JTGOInterviewType = {
  'FaceToFaceInterview': 3,
  'TelePhoneInterview': 4
};
export let JTGOBookInterviewType = {
  FaceToFaceInterview: 'FaceToFaceInterview',
  TelePhoneInterview: 'TelePhoneInterview'
};
export let JTGOInterviewDocumentTypes = {
  'Candidate': 1,
  'Interviewer': 2
};

export let PrintType = {
  Contract: 0,
  Letter: 1,
  Application: 2,
  ReferenceRequest: 3,
  AlliedStarterForm: 4
};

export let FieldTypes = {
     TextBox : 1,
  Dropdown : 2,
  TextArea : 3,
  CheckBoxGroup : 4,
  RadioGroup : 5,
  SectionHeader : 6,
  EmptyLine : 7,
  PopupForm : 8,
  EmptyColumn : 9,
  Date : 10,
  Grid : 13,
  Numeric : 14,
  Mony : 15
};


export let Section = {
  Personal: 1,
  Education: 2,
  Employment: 3,
  References: 4,
  Equalopps: 5,
  AdditionalInfo: 6,
  Crb: 7,
  Cv: 8,
  Declaration: 9,
  AsessmentA: 10,
  TattoImage: 11,
  AssessmentB: 13,
  PreAssessment: 14,
  Onboarding: 21,
  OfferAuthorization: 25,
  ShortList: 27,
  VideoInterview: 28,
  Notes: 29,
  ScreeningForm: 30,
  InitialSift: 31,
  Shortlisting: 32,
  Onlinedisclosure: 33,
  OnlineVideo:34,
  OnlinedisclosureEnhanced: 35,
  IdentityCheck: 36,
  PanelShortlistingFormA: 37,
  PanelShortlistingFormB: 38,
  PanelInterviewingForm: 39,
  PreviousAppointments: 41,
  Redeployment: 40,
  TrustIdRightToWorkCheck: 42,
  TrustIdIdentityCheckForDBS: 43,
  TrustIdDBSCheck: 44,
  Psychometrics:45,
  PartnerPsychometricAssessment:46
}
export enum PanelType{
  PanelShortlistingFormA= "PanelShortlistingFormA",
  PanelShortlistingFormB= "PanelShortlistingFormB",
  PanelInterviewingForm = "PanelInterviewingForm",
  PanelShortlisting ="PanelShortlisting"
}
export var TabPosition = {
  InMoreTab: 0,
  InApplicatioForm: 1
};

export const JobStatus = {
  AwaitingApproval: 'Awaiting Approval'
};
export const KeyCodes = {
  BackSpace : 8,
  Space : 32
};


export var DirectApply = {
  Indeed: 'Indeed',
  CV_Library: 'CV-Library',
  OpenApi: 'Open Api',
}
export enum EducationTypes {
  HigherEducation = "Higher Education",
  SecondaryEducation = "Secondary / Further Education",
  OtherEducation = "Other Training / Qualifications",
  ProfessionalEducation = "Training / Courses"
}
export enum CalendarIcon {
  Accepted = "accepted",
  Declined = "decline",
  Booked = "booked",
  Default = "default"
}


export enum MultiplePanelFormType {
  PanelShortlistingFormA = "PanelA",
  PanelShortlistingFormB = "PanelB",
  PanelInterviewingForm = "PanelInterview",
}



export let TalentApplicationStatus = {
  'ApplicationAlreadExist': 1,
  'ApplicationArchived': 2,
};
export let BookingType = {
  Manual: 'Manual',
  SelfService: 'Self Service'
};
export let JobAccessStatus = {
  RestrictedJob:"RestrictedJob"
};
export let ControlTypes = {
  FirstName: "txtFIRSTNAME",
  LastName: "txtLASTNAME",
  EmailAddress: "txtEMAILADDRESS",
  Mobile: "txtMOBILE",
  Nin: "txtNIN",
  CurrentAddress: "txtCURRENTADDRESS",
  City: "txtCITYTOWN",
  Country: "cmbCOUNTRY",
  PostCode: "txtPOSTCODE",
  County: "txtCOUNTY",
  Title:"txtTITLE"
}
export const ControlName = {
  veteranArmedForces: 'txtVeteranArmedForces',
  customIcon: 'txtCustomIcon',
  empEmployerName: 'txtEMPLOYERNAME',
  empAddress: 'txtADDRESSLINE1',
  empCity: 'txtCITY',
  empCounty: 'txtCOUNTY',
  empCountry: 'txtCOUNTRY',
  empPostCode: 'txtPOSTCODE',
  empContactName: 'txtContactName',
  empEmailAddress: 'txtEmailAddress',
  empPhone: 'txtPhone',
  empFax: 'txtFax',
  empDateFrom: 'dteDATEFROM',
  empDateTo: 'dteDATETO',

  refEmployerName: 'txtEMPLOYERNAME',
  refAddress: 'txtREFEADDRESS1',
  refCity: 'txtREFCITY',
  refCounty: 'txCOUNTY',
  refCountry: 'cmbCOUNTRYID',
  refPostCode: 'txtPOSTCODE',
  refContactName: 'txtCONTACTPERSON',
  refEmailAddress: 'txtCONTACTEMAIL',
  refPhone: 'txtCONTACTPHONE',
  refFax: 'txtCONTACTFAX',
  refDateFrom: 'txtREFDATEFROM',
  refDateTo: 'txtREFDATETO'
};
export const FieldType = {
  I: 'I',
  H: 'H',
  Date: 'DT',
};
export const ControlType = {
  Date: 'DATE',
};
export let TalogyAssessmentStatus = {
  Sent: 1,
  Completed: 2
};
export const FieldName = {
  AddressLine2: "AddressLine2"
}
export const CandidateStatusTileFilter = {
  Default: '',
  Advertised: 'Unreviewed',
  Shortlisting: 'Shortlisting',
  Interviewing: 'Interview',
  Offer: 'Offer'
};

export const TemplateFieldCaptions = {
  GapReason: 'Gap Reason',
};
export enum Interview {
  DeclineReasonMaxLength = 240
}
export let EducationSection = {
  University: 1,
  School: 2,
  OtherEducation: 3,
  ProfessionalEducation: 4
};
export const TemplateEducationType = {
  university: "UNIVERSITY",
  school: "SCHOOL",
  other: "OTHER",
  professionalEducation: "PROFESSIONALEDUCATION"
}
